import clsx from 'clsx';

import { Content } from '@/lib';
import { ButtonDownload } from '@/components/ContentManager/ButtonDownload';
import ContentGalleryProvider from './ContentGallery/ContentGalleryProvider';
import { Header } from './Header';
import { Paragraph } from './Paragraph';
import { List } from './List';
import { Table } from './Table';
import { TableOfContents } from './TableOfContents';
import { Code } from './Code';
import { Row } from './Row';
import { Delimiter } from './Delimiter';
import { Quote } from './Quote';
import { Embed } from './Embed';
import { Warning } from './Warning';
import { Image } from './Image';
import { Button } from './Button';
import { Banner } from './Banner';
import { Spacer } from './Spacer';

export interface ContentManagerProps extends Content.DataWrapper {
  className?: string;
  fluid?: boolean;
}

export function ContentManager({ blocks, fluid, className }: ContentManagerProps) {
  return (
    <div className={clsx(className)}>
      <ContentGalleryProvider content={blocks}>
        {(blocks || []).map(({ type, data, id }) => {
          switch (type) {
            case Content.Type.header:
              return <Header key={id} {...data} fluid={fluid} />;
            case Content.Type.paragraph:
              return <Paragraph key={id} {...data} fluid={fluid} />;
            case Content.Type.image:
              return <Image key={id} {...data} fluid={fluid} />;
            case Content.Type.list:
              return <List key={id} {...data} fluid={fluid} />;
            case Content.Type.table:
              return <Table key={id} {...data} fluid={fluid} />;
            case Content.Type.tableOfContents:
              // eslint-disable-next-line no-case-declarations
              const headers = blocks.filter(
                (block) => block.type === Content.Type.header && (block.data.level === 2 || block.data.level === 3)
              );
              return <TableOfContents headers={headers as Content.DataItem<Content.Type.header, Content.Header>[]} key={id} {...data} />;
            case Content.Type.code:
              return <Code key={id} {...data} fluid={fluid} />;
            case Content.Type.raw:
              return <Row key={id} {...data} fluid={fluid} />;
            case Content.Type.delimiter:
              return <Delimiter key={id} fluid={fluid} />;
            case Content.Type.quote:
              return <Quote key={id} {...data} fluid={fluid} />;
            case Content.Type.embed:
              return <Embed key={id} {...data} />;
            case Content.Type.warning:
              return <Warning key={id} {...data} fluid={fluid} />;
            case Content.Type.button:
              return <Button key={id} {...data} fluid={fluid} />;
            case Content.Type.download:
              return <ButtonDownload key={id} {...data} fluid={fluid} />;
            case Content.Type.banner:
              return <Banner key={id} {...data} fluid={fluid} />;
            case Content.Type.spacer:
            case Content.Type.spacerS:
            case Content.Type.spacerL:
              return <Spacer key={id} type={type} />;
            case Content.Type.attaches:
            default:
              return (
                <div key={id} style={{ padding: 20, background: 'var(--green-lighter)' }}>
                  Block with type <b>{type}</b> currently not supported
                </div>
              );
          }
        })}
      </ContentGalleryProvider>
    </div>
  );
}
